import { useMemo } from 'react'
import styled from 'styled-components'

import { useTrackedWalletLabel } from '@root/features/wallet-tracker/hooks'

import type { Address } from '@root/entities/address/Address'

type TrackedWalletTableMakerCellProps = {
  makerAddress: Address
}

export const TrackedWalletTableMakerCell: React.FC<
  TrackedWalletTableMakerCellProps
> = ({ makerAddress }) => {
  const makerLabel = useTrackedWalletLabel(makerAddress)
  const makerAddressLabel = useMemo(
    () => makerAddress.slice(-8),
    [makerAddress],
  )

  return <Root>{makerLabel ?? makerAddressLabel}</Root>
}

const Root = styled.div`
  color: var(--amber-9);

  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  height: 34px;
`
